import { formatMoney, isCurrencyCode, type JobDetail } from '@nest-recruit/shared';
import type { BudgetNote } from './components/IcpProfileForm';

/** What the salary line of the form may say: the top of the budget, "hidden from you", or that there is none (§L23). */
export function budgetNoteOf(detail: JobDetail): BudgetNote {
  const { salaryBudget } = detail;
  if ((salaryBudget.restrictedFields ?? []).length > 0) return { kind: 'hidden' };
  const currency = salaryBudget.currency;
  if (salaryBudget.maxMinor === null || currency === null || !isCurrencyCode(currency)) return { kind: 'none' };
  return { kind: 'amount', text: formatMoney({ amountMinor: BigInt(salaryBudget.maxMinor), currency }) };
}
